import { getApiGalaxyServer } from 'services';
import { FetchBoardsPayload } from '../types';
import ApiClientManager from 'core/apiClient';

export const getBoards = ({ params, token, config }: BaseApiParams<FetchBoardsPayload>) => {
  // Build custom headers if tenant/realmId are provided to override global cache
  const customHeaders =
    params.tenant && params.realmId
      ? ApiClientManager.buildUrlHeaders({ tenantName: params.tenant, realmId: params.realmId })
      : undefined;

  // Remove header-only fields from params (they shouldn't be sent as query params)
  const { tenant: _tenant, realmId: _realmId, ...queryParams } = params;

  return getApiGalaxyServer(
    `/rails_api/board`,
    { ...config, params: queryParams, ...(customHeaders && { headers: customHeaders }) },
    token,
  );
};
